export default "<owl-date-time-container></owl-date-time-container>"